const CLIENTS_KEY = "fluxocrm_cached_clients";
const QUEUE_KEY = "fluxocrm_pending_orders";

const safeParse = (raw, fallback) => {
  try { return JSON.parse(raw); } catch { return fallback; }
};

export const cacheClients = (clients) => {
  try { localStorage.setItem(CLIENTS_KEY, JSON.stringify(clients || [])); } catch (e) { console.warn("Cache de clientes não salvo (quota?):", e); }
};

export const getCachedClients = () => safeParse(localStorage.getItem(CLIENTS_KEY), []) || [];

const readQueue = () => safeParse(localStorage.getItem(QUEUE_KEY), []) || [];

const writeQueue = (q) => {
  localStorage.setItem(QUEUE_KEY, JSON.stringify(q));
  window.dispatchEvent(new Event("pending-orders-changed"));
};

export const enqueueOrder = (payload, clientName = "") => {
  const q = readQueue();
  q.push({
    localId: `${Date.now()}-${Math.random().toString(36).slice(2, 7)}`,
    payload,
    client_name: clientName,
    created_at: new Date().toISOString(),
  });
  writeQueue(q);
};

export const getPendingOrders = () => readQueue();

export const removePendingOrder = (localId) => writeQueue(readQueue().filter((o) => o.localId !== localId));

export const pendingCount = () => readQueue().length;
